var map = {
	"./book.png": 7058,
	"./coin.png": 1499,
	"./grid.png": 5616,
	"./info-circle.png": 2287,
	"./menu-button.png": 9107,
	"./person.png": 6042,
	"./pie-chart.png": 4090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;